module.exports = __webpack_public_path__ + "img/b8b5bfe33d83507f76c0824db564fd95.svg";